export default "__VITE_ASSET__CWj$YYgO__"